import Case from "case";
import { singularize, pluralize } from "inflection";
import _ from "lodash";
import { ConfigSequelize } from "../model/setup-sequelize/ConfigSequelize";
import { DATA_TYPES } from "../model/setup-sequelize/DataType";
import { Field } from "../model/setup-sequelize/Field";
import { Model } from "../model/setup-sequelize/Model";
export class SequelizeController {
	modelVar = (name: string) => singularize(Case.pascal(name));
	modelFileName = (name: string) => singularize(Case.kebab(name));
	modelProp = (name: string) => singularize(Case.camel(name));
	modelTable = (name: string, snake: any, singularTableNames: any) => {
		const casedName = snake ? Case.snake(name) : Case.camel(name);
		return singularTableNames
			? singularize(casedName)
			: pluralize(casedName);
	};
	fieldProp = (name: string) => singularize(Case.camel(name));
	dbField = (name: string) => singularize(Case.snake(name));

	// tạo file

	keyAndType(field: Field[]) {
		let string: string = "";
		field.map((field) => {
			string += `
${_.camelCase(
				field.name
			)}?: ${this.getTypeBySequelizeType(
				field.type || DATA_TYPES.STRING
			)}; \n \t\t\t`;
		});
		return string;
	}
	getTypeBySequelizeType(type: DATA_TYPES) {
		if (type === DATA_TYPES.BOOLEAN) {
			return `boolean`;
		}
		if (
			type === DATA_TYPES.DECIMAL ||
			type === DATA_TYPES.DOUBLE ||
			type === DATA_TYPES.FLOAT ||
			type === DATA_TYPES.INTEGER
		) {
			return `number`;
		} else {
			return `string`;
		}
	}

	renderModelOpts = (name: string = "", config: ConfigSequelize) =>
		config.snake || config.singularTableNames
			? `, { tableName: '${this.modelTable(
					name,
					config.snake,
					config.singularTableNames
			  )}' }`
			: "";

	renderFields = (fields: Field[], config: ConfigSequelize) => {
		return fields
			.map((field) => this.renderField(field, config))
			.concat(this.renderTimestampFields(config))
			.join(",\n    ");
	};

	renderField = (field: Field, config: ConfigSequelize) => `${this.fieldProp(
		field.name || ""
	)}: {
      ${this.renderFieldKvs(field, config)}
    }`;

	// nơi tạo ra timestamp
	renderTimestampFields = (config: ConfigSequelize) => {
		const fields = [
			{ name: "createdAt", exclude: !config.snake || !config.timestamps },
			{ name: "updatedAt", exclude: !config.snake || !config.timestamps },
			{
				name: "deletedAt",
				exclude: !config.snake || !config.softDeletes,
			},
		];

		return fields
			.filter(({ exclude }) => !exclude)
			.map(({ name }) => this.renderTimeStampKvs(name));
	};

	renderFieldKvs = (filed: Field, { snake = false }) =>
		this.kvs(
			[
				{ k: "type", v: "DataTypes." + filed.type },
				{
					k: "primaryKey",
					v: filed.primaryKey,
					exclude: !filed.primaryKey,
				},
				{
					k: "allowNull",
					v: !filed.required,
					exclude: !filed.required,
				},
				{ k: "unique", v: filed.unique, exclude: !filed.unique },
				{
					k: "field",
					v: `'${this.dbField(filed.name || "")}'`,
					exclude: !snake,
				},
			],
			6
		);
	renderTimeStampKvs = (name: string) => `${this.fieldProp(name)}: {
			${this.kvs(
				[
					{ k: "type", v: "DataTypes.DATE" },
					{ k: "field", v: `'${this.dbField(name)}'` },
				],
				6
			)}
		  }`;

	kvs = (kvs: any, depth = 0, singleLine = false) =>
		kvs
			.filter((kv: any) => !kv.exclude)
			.map(({ k, v }: any) => `${k}: ${v}`)
			.join(`,${singleLine ? " " : `\n${this.indent(depth)}`}`);

	indent = (depth: any) => new Array(depth).fill(" ").join("");
}

//////////////
export const SQL_IDENTIFIER_REGEXP = "^([\\p{L}_][\\p{L}\\p{N}$_ ]*)?$";

export const MAX_SQL_IDENTIFIER_LENGTH = 63;

export const DATA_TYPE_OPTIONS = {
	[DATA_TYPES.STRING]: "String",
	[DATA_TYPES.TEXT]: "Text",
	[DATA_TYPES.INTEGER]: "Integer",
	[DATA_TYPES.FLOAT]: "Float",
	[DATA_TYPES.REAL]: "Real",
	[DATA_TYPES.DOUBLE]: "Double",
	[DATA_TYPES.DECIMAL]: "Decimal",
	[DATA_TYPES.DATE]: "Date",
	[DATA_TYPES.DATEONLY]: "Date (without time)",
	[DATA_TYPES.BOOLEAN]: "Boolean",
	[DATA_TYPES.ARRAY]: "Array",
	[DATA_TYPES.JSON_]: "JSON",
	[DATA_TYPES.BLOB]: "BLOB",
	[DATA_TYPES.UUID]: "UUID",
};

export enum ASSOC_TYPES {
	BELONGS_TO = "BELONGS_TO",
	HAS_ONE = "HAS_ONE",
	HAS_MANY = "HAS_MANY",
	MANY_TO_MANY = "MANY_TO_MANY",
}

export const ASSOC_TYPE_OPTIONS = {
	[ASSOC_TYPES.BELONGS_TO]: "Belongs to",
	[ASSOC_TYPES.HAS_ONE]: "Has one",
	[ASSOC_TYPES.HAS_MANY]: "Has many",
	[ASSOC_TYPES.MANY_TO_MANY]: "Many to many",
};
